import * as React from "react";
import styled from "styled-components";
import { Colors, Icon } from "@blueprintjs/core";
import classNames from "classnames";
import { DrupalColors } from "../DrupalColors";

export interface IBubbleStepsProps {
  steps: number;
  currentStep: number;
  isComplete?: boolean;
  className?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem;
  & > * + * {
    margin-left: 1rem;
  }
`;

const StepNumber = styled.div`
  font-size: 2rem;
  color: ${Colors.WHITE};
`;

const Bubble = styled.div`
  width: 65px;
  height: 65px;
  background-color: rgba(92, 112, 128, 0.6);
  border: 3px solid ${Colors.WHITE};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.completed {
    background-color: ${DrupalColors.blue};
  }

  &.active {
    background-color: ${DrupalColors.blue};
  }
`;

const Line = styled.hr`
  width: 100px;
`;

export const BubbleStepper: React.FunctionComponent<IBubbleStepsProps> = ({
  steps,
  currentStep: progression,
  isComplete = false,
  className,
}) => {
  const computedSteps = React.useMemo(
    () =>
      Array.from(Array(steps).keys()).map((n) => ({
        step: n + 1,
        isCompleted: n + 1 < progression || isComplete,
        isActive: n + 1 === progression,
      })),
    [isComplete, progression, steps]
  );

  return (
    <Container className={className}>
      <BubbleContainer>
        {computedSteps.map((st) => (
          <BubbleContainer key={st.step}>
            <Bubble className={classNames({ completed: st.isCompleted, active: st.isActive })}>
              {st.isCompleted ? (
                <Icon icon="tick" iconSize={32} color={Colors.WHITE} />
              ) : st.step === steps ? (
                <Icon icon="flag" iconSize={32} color={Colors.WHITE} />
              ) : (
                <StepNumber>{st.step}</StepNumber>
              )}
            </Bubble>
            {st.step < steps ? <Line /> : null}
          </BubbleContainer>
        ))}
      </BubbleContainer>
    </Container>
  );
};
